<template>
  <div class="content" style="overflow-x: hidden" id="equipmentmanagement">
    <equipmentdetail v-if="ifDetail" :equipData="equipData" v-on:ifDetail="temChangeifDetail"></equipmentdetail>
    <div v-if="!ifDetail" :class="$i18n.locale=='zh'?'content_bd chineseStyle':'content_bd englishStyle'">
      <el-card class="cardStyle">
        <el-row :gutter="24">
          <el-col :span="3" style="margin-bottom: 20px">
            <el-input v-model="queryparam.name" :placeholder="$t('equipmentName')" size="small"/>
          </el-col>
          <el-col :span="3">
            <el-input v-model="queryparam.equipmentNo" :placeholder="$t('equipmentNo')" size="small"/>
          </el-col>
          <el-col :span="3" v-if="isAdmin">
            <el-input v-model="queryparam.dtuNo" :placeholder="$t('dtuNo')" size="small"/>
          </el-col>
          <el-col :span="2">
            <el-input v-model="queryparam.userName" :placeholder="$t('user')" size="small"/>
          </el-col>
          <el-col :span="2">
            <el-input v-model="queryparam.group" placeholder="设备分组" size="small"/>
          </el-col>
          <el-col :span="8" style="text-align:right;padding-right:30px" v-if="isAdmin">
            <el-button type="primary" size="small" style="background-color: #1677FF;color: #FFFFFF;border-radius:8px;"
                       @click="query(queryparam)"><i
                class="el-icon-search el-icon--left"></i>{{ $t('equipmentmanagement.query') }}
            </el-button>
            <el-button type="primary" size="small" @click="clear"
                       style="margin-left: 15px;;color: #000000;border-radius:8px"><i
                class="el-icon-refresh-right el-icon--left"></i>{{ $t('refresh') }}
            </el-button>
            <el-button @click="addEquipDialog()" type="primary" style="color: #000000;border-radius:8px" size="small"><i
                class="el-icon-plus el-icon--center"></i>{{ $t('add') }}
            </el-button>
            <el-button type="info" size="small" style="background-color: #1677FF;color: #FFFFFF;border-radius:8px;"
                       v-if="aexport" @click="exportData">
              <el-link :href="querystr" target="_blank" style="color:white;margin-top: 2px;margin-bottom: -16px;">&nbsp;{{ $t('export') }}&nbsp;</el-link>
            </el-button>
            <el-button @click="uploadExcelDialog=true"
                       style="background-color: #1677FF;color: #FFFFFF;border-radius:8px;" type="info">
              {{ $t('equipmentmanagement.ExcelBatchModify') }}
            </el-button>
          </el-col>
          <el-col :span="8" style="text-align:right;padding-right:30px" v-else>
            <el-button type="primary" size="small" style="background-color: #1677FF;color: #FFFFFF;border-radius:8px;"
                       @click="query(queryparam)"><i
                class="el-icon-search el-icon--left"></i>{{ $t('equipmentmanagement.query') }}
            </el-button>
            <el-button type="primary" size="small" @click="clear"
                       style="margin-left: 15px;;color: #000000;border-radius:8px"><i
                class="el-icon-refresh-right el-icon--left"></i>{{ $t('refresh') }}
            </el-button>

            <el-button type="info" size="small" v-if="aexport"
                       style="background-color: #1677FF;color: #FFFFFF;border-radius:8px;" @click="exportData">
              <el-link :href="querystr" target="_blank" style="color:white;margin-top: 2px;margin-bottom: -16px;">&nbsp;&nbsp;{{ $t('export') }}&nbsp;&nbsp;</el-link>
            </el-button>
            <el-button @click="uploadExcelDialog=true"
                       style="background-color: #1677FF;color: #FFFFFF;border-radius:8px;" type="info">
              {{ $t('equipmentmanagement.ExcelBatchModify') }}
            </el-button>
          </el-col>
        </el-row>
        <!--26.6.3 JD new required.Show different demand calibers about devices -->
        <el-row :gutter="16" style="padding: 15px 0;">
          <el-col :span="4">
            <div
              class="stat-card"
              :class="{ 'stat-card--selected': selectedFilterFlag === 0 }"
              @click="handleFilterClick(0)"
            >
              <div class="stat-label">全部设备</div>
              <div class="stat-value">{{statisticInfo.totalEquipment}}</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div
              class="stat-card online"
              :class="{ 'stat-card--selected': selectedFilterFlag === 1 }"
              @click="handleFilterClick(1)"
            >
              <div class="stat-label">在线</div>
              <div class="stat-value">{{statisticInfo.onlineEquipment}}</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div
              class="stat-card offline"
              :class="{ 'stat-card--selected': selectedFilterFlag === 2 }"
              @click="handleFilterClick(2)"
            >
              <div class="stat-label">离线</div>
              <div class="stat-value">{{statisticInfo.offlineEquipment}}</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div
              class="stat-card fault"
              :class="{ 'stat-card--selected': selectedFilterFlag === 3 }"
              @click="handleFilterClick(3)"
            >
              <div class="stat-label">故障</div>
              <div class="stat-value">{{statisticInfo.faultEquipment}}</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div
              class="stat-card shortage"
              :class="{ 'stat-card--selected': selectedFilterFlag === 4 }"
              @click="handleFilterClick(4)"
            >
              <div class="stat-label">缺料</div>
              <div class="stat-value">{{statisticInfo.shortageEquipment}}</div>
            </div>
          </el-col>
        </el-row>


        <el-row>
          <el-col :span="24">
            <el-table
                ref="multipleTable"
                :data="equipList"
                stripe
                tooltip-effect="dark"
                style="max-width: 100%;"
                :page-size="pageSize"
                :pager-count="11"
                height="42vh"
                v-loading="equipListloading"
                @sort-change='sortChange'
                @filter-change="filterchange"
                :empty-text="$t('nodata')"
                @select-all="handleAllSelection"
                @selection-change="handleSelection"
            >
              <el-table-column
                  type="index"
                  :label="$t('serialNo')"
                  width="100">
              </el-table-column>
              <el-table-column
                  prop="signalStrength"
                  width="35"

              >
                <template slot-scope="scope">

                  <img src="@/assets/images/xh00.png" style="width: 35px;"
                       v-if="!scope.row.isOnline"/>
                  <template v-else>
                    <img src="@/assets/images/xh00.png" style="width: 35px;" v-if="scope.row.signalStrength == 0"/>
                    <img src="@/assets/images/xh01.png" style="width: 35px;" v-if="scope.row.signalStrength == 1"/>
                    <img src="@/assets/images/xh02.png" style="width: 35px;" v-if="scope.row.signalStrength == 2"/>
                    <img src="@/assets/images/xh03.png" style="width: 35px;" v-if="scope.row.signalStrength == 3"/>
                    <img src="@/assets/images/xh04.png" style="width: 35px;" v-if="scope.row.signalStrength >= 4"/>
                  </template>
                  <span></span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="equipmentNetworkStatus"
                  width="100"
                  column-key="equipmentNetworkStatus"
                  :label="$t('equipmentmanagement.signal')"
              >
                <template slot-scope="scope">
                  <span :class="addClass(scope.row.isOnline ? 1 : 0 )">
                    {{scope.row.isOnline?'在线':'离线'}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="dtuNumber"
                  :label="$t('dtuNo')"
                  v-if="isAdmin"
                  width="170"
              >
              </el-table-column>
              <el-table-column
                  prop="name"
                  :label="$t('equipmentName')"
                  width="250"
                  :show-overflow-tooltip='true'
              >
                <template slot-scope="scope">
                  <div style="color:#516680;text-decoration:underline;cursor:pointer;" class="spanStyle"
                       @click="gotoDetail(scope.row)">{{ scope.row.name }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="number"
                  :label="$t('equipmentNo')"
                  width="200"
              >
                <template slot-scope="scope">
                  <div class="spanStyle">{{ scope.row.number }}</div>
                </template>
              </el-table-column>
              <el-table-column
                  column-key="equipmentType"
                  :label="$t('equipmentmanagement.machineModel')"
                  width="150"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.equipmentTypeName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="user"
                  :label="$t('user')"
                  width="350"
                  :show-overflow-tooltip='true'
              >
                <template slot-scope="scope">
                  {{scope.row.userName}}
                </template>
              </el-table-column>
              <!--26.6.3 JD new requirement:show equipment group-->
              <el-table-column
                label="设备组"
                prop="group"
              >
              </el-table-column>
              <el-table-column
                  id="test"
                  column-key="statusDescription"
                  prop="statusDescription"
                  :label="$t('equipmentmanagement.runningStatus')"
                  :show-overflow-tooltip='true'
                  width="170"
              >
              </el-table-column>
              <el-table-column
                  prop="totalCup"
                  width="120"
                  :label="$t('equipmentmanagement.totalNumberOfCups')"
              >
              </el-table-column>
              <el-table-column
                  prop="totalAmount"
                  width="120"
                  :label="$t('equipmentmanagement.totalAmount')"
              >
              </el-table-column>
              <el-table-column
                  prop="activateTime"
                  :label="$t('equipmentmanagement.activationTime')"
                  sortable
                  :show-overflow-tooltip='true'
                  width="200px"
              >
              </el-table-column>
              <el-table-column
                  prop="flowRecord"
                  width="110"
                  :label="$t('equipmentmanagement.flowRecord')"
              >
                <template slot-scope="scope">
                  <el-progress
                      v-if="scope.row.simCard&&(scope.row.simCard.residualFlow/scope.row.simCard.totalFlow)>0.3&&scope.row.simCard.residualFlow>0"
                      :text-inside="true" :stroke-width="18"
                      :percentage="parseFloat((100*scope.row.simCard.residualFlow/scope.row.simCard.totalFlow).toFixed(1))"
                      status="success"></el-progress>
                  <el-progress
                      v-if="scope.row.simCard&&(scope.row.simCard.residualFlow/scope.row.simCard.totalFlow)<0.1&&scope.row.simCard.residualFlow>0"
                      :text-inside="true" :stroke-width="18"
                      :percentage="parseFloat((100*scope.row.simCard.residualFlow/scope.row.simCard.totalFlow).toFixed(1))"
                      status="exception"></el-progress>
                  <el-progress
                      v-if="scope.row.simCard&&(scope.row.simCard.residualFlow/scope.row.simCard.totalFlow)<0.3&&(scope.row.simCard.residualFlow/scope.row.simCard.totalFlow)>0.1&&scope.row.simCard.residualFlow>0"
                      :text-inside="true" :stroke-width="18"
                      :percentage="parseFloat((100*scope.row.simCard.residualFlow/scope.row.simCard.totalFlow).toFixed(1))"
                      status="warning"></el-progress>
                  <el-progress v-if="scope.row.simCard==null||scope.row.simCard.residualFlow<=0" :text-inside="true"
                               :stroke-width="18" :percentage="parseInt(0)"></el-progress>
                </template>
              </el-table-column>
              <el-table-column
                  :label="$t('operation')"
                  fixed="right"
                  width="400"
              >
                <template slot-scope="scope">
                  <el-button type="text" style="font-size: 100px" @click="gotoDetail(scope.row)" size="small"
                             v-if="aread">{{ $t('check') }}
                  </el-button>
                  <el-button type="text" @click="updateEquip(scope.row)" size="small" v-if="aedit">{{ $t('edit') }}
                  </el-button>
                  <el-popconfirm
                      :confirm-button-text="$t('confirm')"
                      :cancel-button-text="$t('cancel')"
                      :title="$t('equipmentmanagement.whetherToConfirmToDeleteTheEquipment')+'？'"
                      @confirm="deleteEquipment(scope.row.id)"
                      style="margin-left: 10px;"
                  >
                    <el-button slot="reference" type="text" size="small" v-if="adelete"> {{ $t('delete') }}</el-button>
                  </el-popconfirm>
                  <el-button type="text" @click="showEquipConfig(scope.row)" size="small" v-if="aedit">
                    {{ $t('equipmentmanagement.parameterConfiguration') }}
                  </el-button>
                  <el-button type="text" @click="showCopyDialog(scope.row)" size="small" v-if="aedit">
                    {{ $t('equipmentmanagement.copy') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="23" style="margin-top:1%;text-align:right">
            <el-pagination
                background
                style="margin-bottom: 100%;"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentlistpage"
                :page-sizes="[10, 20,50,100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :popper-append-to-body="false"
                :total="totalEquipCount">
            </el-pagination>
          </el-col>
        </el-row>

      </el-card>

    </div>

    <!-- 上传Excel文件 -->
    <el-dialog
        title="上传Excel"
        :visible.sync="uploadExcelDialog"
        :close-on-click-modal="false"
        style="text-align: left;"
        :append-to-body="true"
        width="40%"
    >
      <el-upload
          class="upload-demo"
          ref="upload"
          :action="upLoadUrl"
          :data="upLoadData"
          :headers="upLoadHeaders"
          :on-success="handleAvatarSuccessExcel"
          :on-remove="handleRemove"
          accept=".xlsx"
          :auto-upload="true">
        <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
        <div slot="tip" class="el-upload__tip" style="color:red">1.只能上传xlsx文件</div>
        <div slot="tip" class="el-upload__tip" style="color:red">
          2.必须按照规定表格处理，不能修改表头！不能修改单元格格式！
        </div>
        <div slot="tip" class="el-upload__tip" style="color:red">3.模板中的范例数据可以删除！</div>
        <div slot="tip" class="el-upload__tip" style="color:red">4.必须关闭Excel后导入，否则会失败！</div>
        <div slot="tip" class="el-upload__tip" style="color:red"><a href="/static/equipmentTemplate.xlsx"
                                                                    download="equipmentTemplate1.0.xlsx">模板下载</a>
        </div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
            <el-button @click="uploadExcelDialog = false">取消</el-button>
            <el-button type="primary" style="margin-left: 15px;color: #eceeef;background-color: #315a7d;"
                       @click="importNow">导入</el-button>
        </span>
    </el-dialog>

    <!-- 新增设备对话框 -->
    <el-dialog
        :title="$t('equipmentmanagement.addEquipment')"
        :visible.sync="addDialogVisible"
        :close-on-click-modal="false"
        style="text-align: left;"
        :append-to-body="true"
        width="30%"
        id="addDialog"
    >
      <el-row :gutter="24">
        <el-col :span="18" :offset="3">
          <el-form style="padding: 25px 0 0 0;" size="small" :class="$i18n.locale=='zh'?'chineseForm':'englishForm'">
            <el-form-item :label="$t('dtuNo')+':'" label-width="120px">
              <el-input v-model="postData.dtuNumber" placeholder="2020001" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$t('equipmentName')" label-width="120px">
              <el-input v-model="postData.name" :placeholder="$t('pleaseEnterTheContent')"
                        autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$t('equipmentNo')+':'" label-width="120px">
              <el-input v-model="postData.number" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$t('equipmentmanagement.maximumNumberOfKeys')+':'" label-width="120px"
                          :required="true">
              <el-input v-model="postData.maxKeyCount" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$t('equipmentmanagement.machineModel')+':'" label-width="120px">
              <el-select class="dialog_item_element" v-model="postData.equipmentTypeId"
                         :placeholder="$t('pleaseSelectTheEquipmentModel')" value="1" style="width:100%">
                <el-option v-for="item in equipmentTypes"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备分组" label-width="120px">
              <el-input v-model="postData.group"></el-input>
            </el-form-item>
            <el-form-item :label="$t('equipmentmanagement.salesChannel')+':'" label-width="120px">
              <el-select class="dialog_item_element" v-model="postData.saleWayId"
                         :placeholder="$t('equipmentmanagement.pleaseSelectTheSalesChannel')" value="1"
                         style="width:100%">
                <el-option v-for="item in salefilterdata"
                           :key="item.value"
                           :label="item.text"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">{{ $t('cancel') }}</el-button>
                <el-button type="primary" style="margin-left: 15px;color: #eceeef;background-color: #315a7d;"
                           @click="saveEquipment()" v-preventReClick>{{ $t('confirm') }}</el-button>
            </span>
    </el-dialog>

    <!-- 设备信息编辑对话框 -->
    <el-dialog
        :title="$t('equipmentmanagement.editEquipmentInfo')"
        :visible.sync="editDialogVisible"
        :close-on-click-modal="false"
        style="text-align: left;"
        :append-to-body="true"
        width="30%"
        :class="$i18n.locale=='zh'?'chineseForm':'englishForm'"
    >
      <el-row :gutter="24">
        <el-col :span="18" :offset="3">
          <el-form style="padding: 25px 0 0 0;" size="small">
            <el-form-item :label="$t('dtuNo')+'：'" label-width="130px" :required="true">
              <el-input v-if="this.$account.data.isAdmin" v-model="updateData.dtuNumber"
                        :placeholder="updateData.dtuNumber" autocomplete="off"></el-input>
              <el-input v-else v-model="updateData.dtuNumber" :placeholder="updateData.dtuNumber" autocomplete="off"
                        :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$t('equipmentmanagement.simCardNo')+'：'" label-width="130px">
              <el-input v-if="this.$account.data.isAdmin" v-model="updateData.cardNumber"
                        :placeholder="updateData.cardNumber" autocomplete="off"></el-input>
              <el-input v-else v-model="updateData.cardNumber" :placeholder="updateData.cardNumber" autocomplete="off"
                        :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$t('equipmentName')+'：'" label-width="130px">
              <el-input v-model="updateData.name" :placeholder="updateData.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$t('equipmentNo')+'：'" label-width="130px" :required="true">
              <el-input v-if="this.$account.data.isAdmin" v-model="updateData.number" autocomplete="off"
                        :placeholder="updateData.number"></el-input>
              <el-input v-else v-model="updateData.number" autocomplete="off" :placeholder="updateData.number"
                        :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$t('equipmentmanagement.maximumNumberOfKeys')+'：'" label-width="130px"
                          :required="true">
              <el-input v-if="this.$account.data.isAdmin" v-model="updateData.maxKeyCount" autocomplete="off"
                        :placeholder="updateData.maxKeyCount"></el-input>
              <el-input v-else v-model="updateData.maxKeyCount" autocomplete="off" :placeholder="updateData.maxKeyCount"
                        :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$t('equipmentmanagement.machineModel')+'：'" label-width="130px">
              <el-select v-if="this.$account.data.isAdmin" class="dialog_item_element"
                         v-model="updateData.equipmentTypeId" style="width:100%">
                <el-option v-for="item in equipmentTypes"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
              <el-input v-else v-model="updateData.equipmentTypeId" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="设备分组" label-width="130px">
              <el-input v-model="updateData.group"></el-input>
            </el-form-item>
            <el-form-item :label="$t('equipmentmanagement.salesChannel')+'：'" label-width="130px">
              <el-select class="dialog_item_element" v-model="updateData.saleWayId"
                         :placeholder="$t('equipmentmanagement.noSalesChannel')" value="1" style="width:100%">
                <el-option v-for="item in salefilterdata"
                           :key="item.value"
                           :label="item.text"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备地址：" label-width="130px">
              <el-input v-model="updateData.actualAddress"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">{{ $t('cancel') }}</el-button>
                <el-button type="primary" style="margin-left: 15px;color: #eceeef;background-color: #315a7d;"
                           @click="saveEquipment">{{ $t('confirm') }}</el-button>
            </span>
    </el-dialog>

    <!-- 手动选取设备位置 -->
    <el-dialog
        width="60%"
        :title="$t('equipmentmanagement.manuallySelectTheEquipmentLocation')"
        :visible.sync="chooseAdressVisible"
        :close-on-click-modal="false"
        append-to-body>
      <mapComponent v-model="showMapComponent" v-on:cancel="chooseAdressVisible = false" v-on:map-confirm="confirmMap"
                    :longitude="updateData.longitude" :latitude="updateData.latitude"></mapComponent>
    </el-dialog>

    <!--选择配方库弹窗-->
    <el-dialog
        width="30%"
        :title="$t('equipmentmanagement.selectRecipeLibraryToAssign')"
        :visible.sync="chooseCupTypeVisible"
        :close-on-click-modal="false"
        append-to-body>
      <el-button type="info" size="small" @click="speedGroup()">{{ $t("equipmentmanagement.selectByExistingGroup") }}
      </el-button>
      <el-button size="mini" @click="loadAssignedCupType(1)" style="z-index:99999999;position: absolute;right: 32px;">
        {{ $t("equipmentmanagement.checkAssigned") }}
      </el-button>
      <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="chooseCupTypeVisible = false">{{ $t("cancel") }}</el-button>
            <el-button size="mini" type="primary" @click="confirmSelectCupTypeList">{{ $t("confirm") }}</el-button>
            </span>
    </el-dialog>

    <!--选择配方库弹窗-->
    <el-dialog
        width="60%"
        :title="$t('equipmentmanagement.selectRecipeLibraryToAssign')"
        :visible.sync="chooseMultiCupTypeVisible"
        :close-on-click-modal="false"
        append-to-body>
      <el-button type="info" size="small" @click="speedMultiGroup()">
        {{ $t('equipmentmanagement.selectByExistingGroup') }}
      </el-button>
      <el-button size="mini" @click="loadAssignedCupType(1)" style="z-index:99999999;position: absolute;right: 32px;">
        {{ $t('equipmentmanagement.checkAssigned') }}
      </el-button>
      <el-divider></el-divider>
      <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="chooseMultiCupTypeVisible = false">{{ $t("cancel") }}</el-button>
            <el-button size="mini" type="primary" @click="confirmMultiSelectCupTypeList">{{ $t("confirm") }}</el-button>
            </span>
    </el-dialog>

    <!-- 查看配方 -->
    <el-dialog
        :title="$t('equipmentmanagement.checkRecipe')"
        :visible.sync="assignedCupDialogVisible"
        :close-on-click-modal="false"
        style="text-align: left;"
        :append-to-body="true"
        width="65%"
    >
      <el-card style="margin-top:18px;padding:0px !important;box-shadow:none !important; border:solid 1px #DCDFE6;">
        <el-row>
          <el-col :span="24">
            <el-table
                ref="multipleTable"
                :data="cupinfoList"
                stripe
                tooltip-effect="dark"
                style="width: 100%;"
                v-loading="cload"
                max-height="520"
                :page-size="pageSize"
                :pager-count="11"
            >
              <el-table-column
                  type="index"
                  :label="$t('serialNo')"
                  width="100">
              </el-table-column>
              <el-table-column
                  prop="DrinkName"
                  :label="$t('beverageName')"
              >
                <template slot-scope="scope">
                  <label>{{ scope.row.beverage ? scope.row.beverage.name : "" }}</label>
                </template>
              </el-table-column>
              <el-table-column
                  :label="$t('beverageImage')"
              >
                <template slot-scope="scope">
                  <el-image style="width: 100px; height: 100px" fit="fill" class="img" v-if="scope.row.beverage.picture"
                            :src="scope.row.beverage.picture.path"></el-image>
                  <label v-else>{{ $t("equipmentmanagement.noPicture") }}</label>
                </template>
              </el-table-column>

              <el-table-column
                  :label="$t('equipmentmanagement.ingredientName')"
              >
                <template slot-scope="scope">
                  <label v-for="(item,index) in scope.row.beverage.rawMaterials"
                         :key="index">{{ item ? item.name : "" }}&nbsp;</label>
                </template>
              </el-table-column>
              <el-table-column
                  :label="$t('equipmentmanagement.category')"
              >
                <template slot-scope="scope">
                  <label
                      v-if="scope.row.beverage&&scope.row.beverage.beverageCatalog==1">{{ $t('equipmentmanagement.coffee') }}</label>
                  <label
                      v-if="scope.row.beverage&&scope.row.beverage.beverageCatalog==2">{{ $t('equipmentmanagement.milkTea') }}</label>
                  <label
                      v-if="scope.row.beverage&&scope.row.beverage.beverageCatalog==3">{{ $t('equipmentmanagement.soybeanMilk') }}</label>
                  <label
                      v-if="scope.row.beverage&&scope.row.beverage.beverageCatalog==4">{{ $t('equipmentmanagement.juice') }}</label>
                </template>
              </el-table-column>

              <el-table-column
                  :label="$t('equipmentmanagement.cupType')"
              >
                <template slot-scope="scope">
                  <label v-if="scope.row.cupSize">{{ scope.row.cupSize.name }}</label>

                </template>
              </el-table-column>
              <el-table-column
                  :label="$t('selectedImage')"
              >
                <template slot-scope="scope">
                  <el-image style="width: 100px; height: 100px" fit="fill" class="img" v-if="scope.row.checkedPicture"
                            :src="scope.row.checkedPicture.path"></el-image>
                  <label v-else>{{ $t('noPicture') }}</label>
                </template>
              </el-table-column>
              <el-table-column
                  :label="$t('notSelectedImage')"
              >
                <template slot-scope="scope">
                  <el-image style="width: 100px; height: 100px" fit="fill" class="img" v-if="scope.row.unCheckedPicture"
                            :src="scope.row.unCheckedPicture.path"></el-image>
                  <label v-else>{{ $t('noPicture') }}</label>
                </template>
              </el-table-column>

            </el-table>
          </el-col>
        </el-row>
        <el-row style="margin-top:2%;text-align:center">
          <el-col :span="24" style="margin-top:2%;text-align:right;">
            <el-pagination
                @size-change="handleSizeChangepf"
                @current-change="handleCurrentChangepf"
                :page-sizes="[10, 20,50,100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="cupTypeTotalCount">
            </el-pagination>
          </el-col>
        </el-row>
      </el-card>
      <span slot="footer" class="dialog-footer">
                    <el-button type="primary" style="margin-left: 15px;color: #eceeef;background-color: #315a7d;"
                               @click="assignedCupDialogVisible = false">{{ $t("confirm") }}</el-button>
                </span>
    </el-dialog>

    <!-- 出杯记录 -->
    <el-dialog
        :title="$t('equipmentmanagement.recipeAssignment')"
        :visible.sync="CupDialogVisible"
        :close-on-click-modal="false"
        style="text-align: left;"
        :append-to-body="true"
    >
      <el-card style="width:100%;height:100%">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-date-picker
                style="width: 100%;"
                type="datetimerange"
                range-separator="-"
                :start-placeholder="$t('startDate')"
                :end-placeholder="$t('endDate')"
                size="small"
            >
            </el-date-picker>
          </el-col>
        </el-row>
        <el-table
            ref="multipleTable"
            :data="CupList"
            stripe
            tooltip-effect="dark"
            style="width: 100%;margin-top: 10px;"
            :page-size="pageSize"
            :pager-count="11"
        >
          <el-table-column
              type="index"
              :label="$t('serialNo')"
              width="100">
          </el-table-column>
          <el-table-column
              prop="Drink"
              :label="$t('beverageName')"
          >
          </el-table-column>
          <el-table-column
              prop="Cup"
              :label="$t('equipmentmanagement.cuptype')"
          >
          </el-table-column>
          <el-table-column
              prop="Price"
              :label="$t('equipmentmanagement.amount')"
          >
          </el-table-column>
          <el-table-column
              prop="Time"
              :label="$t('equipmentmanagement.dispensingTime')"
          >
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="24" style="margin-top:2%;text-align:center">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage4"
                :page-sizes="[10, 20,50,100]"
                :page-size="100"
                layout="total, sizes, prev, pager, next, jumper"
                :total="400">
            </el-pagination>
          </el-col>
        </el-row>
      </el-card>
      <span slot="footer" class="dialog-footer">
                <el-button type="primary" style="margin-left: 15px;color: #eceeef;background-color: #315a7d;"
                           @click="CupDialogVisible = false">{{ $t('confirm') }}</el-button>
            </span>
    </el-dialog>

    <!--参数配置弹窗-->
    <el-dialog
        width="60%"
        :title="$t('equipmentmanagement.equipmentParameterConfiguration')"
        :visible.sync="equipmentCofigShow"
        :close-on-click-modal="false"
        v-if="equipmentCofigShow"
        append-to-body>
      <equipPramConfig :initValue="equipmentInit" ref="epc" @closeEqDialog="closeEqDialog"></equipPramConfig>
    </el-dialog>

    <el-dialog
        :title="$t('equipmentmanagement.selectByExistingGroup')"
        :visible.sync="DialogGroupVisible"
        :close-on-click-modal="false"
        style="text-align: left;"
        :append-to-body="true"
        width="30%"
    >
      <el-tag style="margin:8px;font-size:15px" v-for="(item, index) in cuptypeGroupList" :key="index"
              @click="selectGroup(item)" type="success"
              :class="{bgcoloraaa:selectedCuptypeGroupName.find(x=>x ==item)}">{{ item }}
      </el-tag>
      <span slot="footer" class="dialog-footer">
            <el-button @click="DialogGroupVisible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" style="margin-left: 15px;color: #eceeef;background-color: #315a7d;"
                       @click="groupArrange()">{{ $t('equipmentmanagement.confirmAssignment') }}</el-button>
        </span>
    </el-dialog>

    <el-dialog
        :title="$t('equipmentmanagement.selectByExistingGroup')"
        :visible.sync="DialogMultiGroupVisible"
        :close-on-click-modal="false"
        style="text-align: left;"
        :append-to-body="true"
        width="30%"
    >
      <el-tag style="margin:8px;font-size:15px" v-for="(item, index) in cuptypeGroupList" :key="index"
              @click="selectGroup(item)" type="success"
              :class="{bgcoloraaa:selectedCuptypeGroupName.find(x=>x ==item)}">{{ item }}
      </el-tag>
      <span slot="footer" class="dialog-footer">
            <el-button @click="DialogMultiGroupVisible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" style="margin-left: 15px;color: #eceeef;background-color: #315a7d;"
                       @click="groupMultiArrange()">{{ $t('equipmentmanagement.confirmAssignment') }}</el-button>
        </span>
    </el-dialog>
    <el-dialog
        width="60%"
        :title="$t('equipmentmanagement.selectTheEquipmentToBeCopied')"
        :visible.sync="equipmentCopyDialog"
        v-if="equipmentCopyDialog"
        :close-on-click-modal="false"
        append-to-body>
      <EquipmentCopy :equipmentCopyInit="equipmentCopyInit"></EquipmentCopy>
    </el-dialog>
  </div>
</template>

<script>
import equipPramConfig from '../equipmentmanagement/equipPramConfig.vue';
import equipmentdetail from '../equipmentmanagement/equipment_detail.vue';
import EquipmentCopy from '../equipmentmanagement/EquipmentCopy.vue';
// TS
import {EquipmentService} from '@/service/EquipmentService'

export default {
  components: {
    equipPramConfig,
    mapComponent: () => import("../../components/mapComponent.vue"),
    equipmentdetail,
    EquipmentCopy
  },
  name: "equipmentmanagement",
  data() {
    return {
      selectedFilterFlag: 0,
      uploadExcelDialog: false,
      globalfilterMultiple: false,
      currentTime: 0,
      equipListloading: true,
      equipData: [],
      cload: true,
      pageSize: 10,
      pageIndex: 1,
      ifDetail: false,
      filterParam: new Object(),
      queryparam: new Object(),
      postData: new Object(),
      order: '',
      prop: '',
      sequence: true,
      equipList: [],
      cuptypeGroupList: [],
      DialogGroupVisible: false,
      editDialogVisible: false,
      addDialogVisible: false,
      CupDialogVisible: false,
      chooseCupTypeVisible: false,
      assignedCupDialogVisible: false,
      equipmentCofigShow: false,
      chooseAdressVisible: false,
      showMapComponent: '',
      equipmentInit: new Object(),
      assignInfo: new Object(),
      UserTreeDialogVisible: false,
      detail_route: 'equipment_detail',
      currentPage4: 1,
      currentlistpage: 1,
      dtuNumber: '',
      equipName: '',
      saleWayId: null,
      equipNo: '',
      maxKeyCount: 0,
      typeConfig: '',
      totalEquipCount: 0,
      cupTypeTotalCount: 0,
      autoLocation: '',
      saleWayName: '',
      saleList: [],
      saleNote: '',
      salefilterdata: [],
      equipfilterdata: [],
      statusfilterdata: [],// 状态筛选
      selectedCupTypeList: [],
      selectedCuptypeGroupName: [],
      cupinfoList: [],
      options: [],
      updateData: new Object(),
      CupList: [],
      value: '',
      props: {
        label: 'name',
        children: 'zones'
      },
      count: 1,
      param: new Object(),
      authArray: [],
      isAdmin: false,
      aread: false,
      aedit: false,
      adelete: false,
      aexport: false,
      equipTypeId: 0,
      currentSelectedEquip: null,
      chooseMultiCupTypeVisible: false,
      DialogMultiGroupVisible: false,
      isallselect: false,
      equipTypeList: [],
      // checkeSelectable:true,
      equipmentCopyDialog: false,
      equipmentCopyInit: null,
      querystr: '',
      upLoadUrl: this.$httpservice.host + "api/File/Upload",
      upLoadData: {filecatalog: 10},
      upLoadHeaders: {authorization: "bearer " + this.$account.data.token},
      fileLibId: -1,// 已上传成功的文件ID

      // The params about ts
      equipmentService:null,
      isEdit:false,// 是否是修改
      equipmentTypes:[],
      statisticInfo:{
        totalEquipment:0,
        onlineEquipment:0,
        offlineEquipment:0,
        faultEquipment:0,
        shortageEquipment:0
      },// 顶部的表头数据
    }
  },
  created() {
    this.equipmentService = new EquipmentService(this.$httpservice)
  },
  mounted() {
    this.loadEquipments();
    this.statisticEquipments()

    this.updateData = {
      id: 0,
      dtuNumber: '',
      name: '',
      number: '',
      equipmentTypeId: 0,
      saleWayId: 0,
      maxKeyCount: 0,
      cardNumber: '',
      manualAddress: '',//手动定位地址
      actualAddress: '',// 自动定位地址
      latitude: 30,
      longitude: 120,
      group:''
    }

    if (this.$account.data.isAdmin) {
      this.isAdmin = this.$account.data.isAdmin;
      this.aread = true,
          this.aedit = true,
          this.adelete = true,
          this.aexport = true
    } else {
      //配置权限 权限类型 0浏览 1编辑 2删除 3导出
      this.$account.data.authorities.forEach(e => {
        if (e.menu.name == "设备列表") {
          this.authArray.push(e.authorityType);
        }
      });
      this.authArray.forEach(e => {
        switch (e) {
          case 0:
            this.aread = true;
            break
          case 1:
            this.aedit = true;
            break
          case 2:
            this.adelete = true;
            break
          case 3:
            this.aexport = true;
            break
        }
      })
    }

    this.getSaleWayList();
    //this.getEquipTypeList();
    // Get equipment types
    this.loadEquipmentTypes()
  },
  methods: {
    /**
     * TS重构现有方法
     * ecs2uJ
     * 2026/6/2
     */
    async loadEquipments() {
      this.equipListloading = true
      const response = await this.equipmentService.getEquipmentList({
        pageIndex:this.pageIndex,
        pageSize:this.pageSize,
        name:this.queryparam.name,
        number:this.queryparam.equipmentNo,
        dtuNumber:this.queryparam.dtuNo,
        group:this.queryparam.group,
        filterFlag:this.queryparam.filterFlag
      })

      if (response.success) {
        this.equipList = response.data
        this.totalCount = response.totalCount
      } else {
        this.$message.error(response.message)
      }

      this.equipListloading = false
    },

    handleFilterClick(filterFlag) {
      this.selectedFilterFlag = filterFlag
      this.queryparam.filterFlag = filterFlag
      this.loadEquipments()
    },

    async saveEquipment(){
      if(this.isEdit){
        // edit
        await this.equipmentService.updateEquipment(this.updateData)
      }else{
        // add
        await this.equipmentService.createEquipment(this.postData)
      }
      // close dialog
      this.$message.success("保存成功")
      this.addDialogVisible  = false
      this.editDialogVisible = false
      // reload data
      await this.loadEquipments()
    },

    async deleteEquipment(id){
      let response = await this.equipmentService.deleteEquipment(id)
      if(response.success){
        this.$message.success("删除成功")
      }else{
        this.$message.error(response.message)
      }
      // reload data
      await this.loadEquipments()
    },

    async statisticEquipments(){
      let response = await this.equipmentService.statisticEquipments()
      if(response.success){
        this.statisticInfo = response.data
        console.log("统计数据",this.statisticInfo)
      }
    },

    /**
     * 加载设备类型列表
     * @returns {Promise<void>}
     */
    async loadEquipmentTypes(){
      let response = await this.equipmentService.getEquipmentTypes()
      if (response.success) {
        this.equipmentTypes = response.data
      } else {
        this.$message.error(response.message)
      }
    },




    //获取已选择
    handleSelection(selection) {
      this.selectedEquipList = selection
      this.allselectedEquipList = this.lastselectedEquipList.concat(this.selectedEquipList)
    },
    //全选
    handleAllSelection(selection) {
      console.log(selection)
      if (selection.length > 0) {
        this.isallselect = true
      } else {
        this.isallselect = false
      }
    },
    checkeSelectable() {
      if (this.isallselect) {
        return false
      } else {
        return true
      }
    },
    bulkAllocation() {
      if (this.allselectedEquipList.length < 1) {
        this.$message.error(this.$t('logginaccount.pleaseTickTheEquipmentFirst'));
      } else {
        this.chooseMultiCupTypeVisible = true;
        this.$nextTick(() => {
          this.$refs.seletcCup.loadCupTypes(1)
          this.$refs.seletcCup.$refs.multipleTable.clearSelection();
          this.$refs.seletcCup.allselectedCupTypeList = [];
          this.$refs.seletcCup.selectedCupTypeList = [];
          this.$refs.seletcCup.selectedCuptypeGroup = null;
        })

        this.loadCupGroups()
      }
    },
    closeEqDialog() {
      this.equipmentCofigShow = false
    },
    filterHandler(value, row, column) {
      // const property = column['property'];
      return row['equipmentTypeID'] === value;
    },
    // 运行状态筛选
    statusFilterHandler(value, row, column) {
      return row['statusDescription'] === value

    },
    //选中分组
    selectGroup(e) {
      if (this.selectedCuptypeGroupName.find(x => x == e)) {

      } else {
        this.selectedCuptypeGroupName.push(e);
      }
      console.log(this.selectedCuptypeGroupName)
    },
    speedGroup() {
      this.DialogGroupVisible = true;
      this.selectedCuptypeGroupName = [];
    },
    speedMultiGroup() {
      this.DialogMultiGroupVisible = true
      this.selectedCuptypeGroupName = [];
    },
    loadCupGroups(id) {
      let that = this;
      if (id) {
        this.$httpservice.get("api/Beverage/CupTypeGroups?equipmentTypeId=" + id).then(
            function (data) {
              if (data.body.code == "200") {
                that.cuptypeGroupList = data.body.data;
              } else {
                that.$message({
                  message: data.body.msg,
                  type: 'warning'
                });
              }
            },
            function (data) {
              let statusCode = data.status;
              that.$message({
                message: that.$t('queryFailedStatusCode') + statusCode,
                type: 'warning'
              });
            }
        );
      } else {
        this.$httpservice.get("api/Beverage/CupTypeGroups").then(
            function (data) {
              if (data.body.code == "200") {
                that.cuptypeGroupList = data.body.data;
              } else {
                that.$message({
                  message: data.body.msg,
                  type: 'warning'
                });
              }
            },
            function (data) {
              let statusCode = data.status;
              that.$message({
                message: that.$t('queryFailedStatusCode') + statusCode,
                type: 'warning'
              });
            }
        );
      }

    },
    groupMultiArrange() {
      let that = this
      if (this.isallselect) {
        let name = this.queryparam.name == undefined ? '' : this.queryparam.name;
        let equipmentNo = this.queryparam.equipmentNo == undefined ? '' : this.queryparam.equipmentNo;
        let salewayNo = this.queryparam.salewayNo == undefined ? '' : this.queryparam.salewayNo;
        let userName = this.queryparam.userName == undefined ? '' : this.queryparam.userName;
        let equipmentTypeId = this.queryparam.equipmentTypeId == undefined ? '' : this.queryparam.equipmentTypeId;
        let dtuNo = this.queryparam.dtuNo == undefined ? '' : this.queryparam.dtuNo;

        this.$httpservice.post("api/Equipment/BindCupType4SpecificEquipmentsByGroup?name=" + name + "&equipmentNo=" + dtuNo + "&dtuNo=" + dtuNo + "&salewayNo=" + salewayNo + "&userName=" + userName + "&equipmentType_ID=" + equipmentTypeId, this.selectedCuptypeGroupName).then(res => {
          if (res.body.code == "200") {
            this.$message({
              message: that.$t('equipmentmanagement.batchAssignmentTaskCreatedSuccessfully'),
              type: 'success'
            });
            that.DialogMultiGroupVisible = false;

            that.chooseMultiCupTypeVisible = false;
          } else {
            this.$message({
              message: res.body.msg,
              type: 'warning'
            });
          }
        })
      } else {
        let obj = new Object();
        obj.equipmentIDs = [];
        this.allselectedEquipList.forEach(e => {
          obj.equipmentIDs.push(e.id)
        })
        obj.groupNames = [];
        this.selectedCuptypeGroupName.forEach(e => {
          obj.groupNames.push(e)
        })
        let that = this;
        if (that.selectedCuptypeGroupName.length > 0) {
          this.$httpservice.post("api/Equipment/BatchBindCupTypeByGroup", obj).then(
              function (data) {
                if (data.body.code == "200") {
                  that.$message({
                    message: data.body.msg,
                    type: 'success'
                  });
                  that.DialogMultiGroupVisible = false;

                  that.chooseMultiCupTypeVisible = false;
                  // that.$refs.seletcCup.loadCupTypes(1)
                }
              },
              function (data) {
                let statusCode = data.status;
                that.$message({
                  message: that.$t('queryFailedStatusCode') + statusCode,
                  type: 'warning'
                });
              }
          );
        } else {
          that.$message({
            message: that.$t('surong.pleaseSelectAGroup'),
            type: 'warning'
          });
        }
      }
    },
    groupArrange() {
      let that = this;
      if (that.selectedCuptypeGroupName.length > 0) {
        this.$httpservice.post("api/Equipment/BindCupTypeByGroup?equipmentId=" + that.assignInfo.id, that.selectedCuptypeGroupName).then(
            function (data) {
              if (data.body.code == "200") {
                that.$message({
                  message: data.body.msg,
                  type: 'success'
                });
                that.DialogGroupVisible = false;
              }
            },
            function (data) {
              let statusCode = data.status;
              that.$message({
                message: that.$t('queryFailedStatusCode') + statusCode,
                type: 'warning'
              });
            }
        )
      } else {
        that.$message({
          message: that.$t('surong.pleaseSelectAGroup'),
          type: 'warning'
        })
      }

    },
    //公共筛选方法
    filterchange(filters) {
      //分配情况
      if (Object.keys(filters) == "state") {
        if (filters["state"].length > 0) {
          let value = filters["state"][0];
          this.filterParam.state = value
        } else {
          this.filterParam.state = null;
        }
        this.loadEquipList(1);
        //销售渠道
      } else if (Object.keys(filters) == "saleWay") {
        if (filters["saleWay"].length > 0) {
          let value = filters["saleWay"][0];
          this.filterParam.salewayId = value
        } else {
          this.filterParam.salewayId = null;
        }
        this.loadEquipList(1);
        //设备型号
      } else if (Object.keys(filters) == "equipmentType") {
        if (filters["equipmentType"].length > 0) {
          let value = filters["equipmentType"][0];
          this.filterParam.equipmentTypeId = value
        } else {
          this.filterParam.equipmentTypeId = null;
        }
        this.loadEquipList(1);
      }
      //网络状态
      else if (Object.keys(filters) == "equipmentNetworkStatus") {
        if (filters["equipmentNetworkStatus"].length > 0) {
          let value = filters["equipmentNetworkStatus"][0];
          this.filterParam.equipmentNetworkStatus = value
        } else {
          this.filterParam.equipmentNetworkStatus = null;
        }
        this.loadEquipList(1);
      } else if (Object.keys(filters) == "statusDescription") {
        if (filters["statusDescription"].length > 0) {
          let value = filters["statusDescription"][0];
          this.filterParam.statusDescription = value
        } else {
          this.filterParam.statusDescription = null;
        }
        this.loadEquipList(1);
      }
      return this.filterParam;
    },
    goTo(index, e) {
      //直接跳转
      this.$router.push("/home/" + index + "?id=" + e.id + "&number=" + e.dtuNumber);
    },
    //查询
    query() {
      this.loadEquipments();
    },
    //清空筛选及排序
    clear() {
      this.$refs.multipleTable.clearSort();
      this.$refs.multipleTable.clearFilter();
      this.currentlistpage = 1;
      this.filterParam = {};
      this.queryparam = {}
      this.order = '';
      this.loadEquipList(1);
    },
    //加载设备列表
    loadEquipList(pageIndex) {
      this.equipListloading = true;
      this.currentTime = new Date().getTime();
      if (this.order === "descending" || this.order === "ascending") {
        this.param = {
          pageIndex: pageIndex,
          pageSize: this.pageSize,
          order: this.prop,
          sequence: this.sequence,
          ...this.filterParam,
          ...this.queryparam
        };
      } else {
        this.param = {
          pageIndex: pageIndex,
          pageSize: this.pageSize,
          ...this.filterParam,
          ...this.queryparam
        };
      }

      let that = this;
      that.statusfilterdata = []
      this.$httpservice.get("api/Equipment/List", that.param).then(
          function (data) {
            that.equipListloading = false;
            if (data.body.code == "200") {
              that.equipList = data.body.data;
              that.totalEquipCount = data.body.totalCount;

              that.selectedEquipList = []
              that.lastselectedEquipList = []
              let l = []
              for (let i in that.allselectedEquipList) {
                let f = data.body.data.find(item => {
                  return item.id == that.allselectedEquipList[i].id
                })
                if (f) {
                  that.selectedEquipList.push(f)
                  l.push(f)
                } else {
                  that.lastselectedEquipList.push(that.allselectedEquipList[i])
                }
              }
              that.allselectedEquipList = []
              setTimeout(() => {
                for (let i in l) {
                  that.$refs.multipleTable.toggleRowSelection(l[i]);
                }
              }, 0)
              that.$httpservice.get("api/Equipment/CurrentStatus", that.param).then(res => {
                if (res.body.code == 200) {
                  let tempArr = Array.from(new Set(res.body.data));
                  tempArr.forEach(item => {
                    that.statusfilterdata.push({text: item, value: item})
                  })
                } else {

                }
              })
            } else {
              that.$message({
                message: data.body.msg,
                type: 'danger'
              });
            }
          },
          function (data) {
            that.equipListloading = false;
            let statusCode = data.status;
            that.$message({
              message: that.$t('queryFailedStatusCode') + statusCode,
              type: 'warning'
            });
          }
      );
    },
    //逆编码自动定位，先写死
    // 牛啊key直接写死在前端
    getLocationByDecode(LAC, CID) {
      let bodydata = new Object()
      bodydata = {
        ver: "1.0",
        trace: false,
        prod: "test_loc_api",
        src: "baidu_loc_api",
        key: "Tvu7LZLPXKTzE9Fg3SzBGciGLMFGcRCG",
        body: [{
          accesstype: 0,
          cdma: 0,
          imei: "xxxxxxxxxxxxxxx",
          network: "GSM",
          bts: "460,0,4163,21297934,-124",
          ctime: Date.parse(new Date()).toString()
        }]
      }
      this.$httpservice.postForLocation("locapi/v2", bodydata).then(result => {
        if (result.status == '200') {
          let str = result.body.body.location;
        } else {
          this.$message.error(this.$t('equipmentmanagement.automaticPositioningAcquisitionFailed'))
        }
      });
    },
    //跳转详情页
    gotoDetail(e) {
      this.ifDetail = true;
      this.equipData = JSON.parse(JSON.stringify(e));
      if (e.actualAddress == null) {
        this.equipData.autoLocation = this.$t('equipmentmanagement.theEquipmentHasNoLocationInformationTemporarily')
      } else {
        this.equipData.autoLocation = this.$t('equipmentmanagement.automaticPositioning')
        this.equipData.autoLocation = e.actualAddress
        this.$forceUpdate();
      }
    },
    //子组件改变详情是否显示
    temChangeifDetail() {
      this.ifDetail = !this.ifDetail
    },
    //监听排序
    sortChange({prop, order}) {
      this.order = order
      this.prop = prop;
      if (order == "ascending") {
        this.sequence = true;
      } else if (order == "descending") {
        this.sequence = false;
      } else {
        this.sequence = null
      }
      this.loadEquipList(this.currentlistpage);

    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.loadEquipList(1)
      this.currentlistpage = 1

    },
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.currentlistpage = e
      this.loadEquipList(e)

    },
    //获取销售渠道筛选
    getSaleWayList() {
      let that = this;
      this.$httpservice.get("api/BasicData/SaleWays").then(
          function (data) {
            if (data.body.code == "200") {
              that.saleList = data.body.data;
              that.totalSaleCount = data.body.totalCount;
              //销售渠道名称筛选数组
              for (let index in that.saleList) {
                that.salefilterdata.push({
                  text: that.saleList[index].name,
                  value: that.saleList[index].id
                });
              }
              that.salefilterdata.push({
                text: that.$t('equipmentmanagement.noSalesChannelTemporarily'),
                value: 0
              });
            } else {
              that.$message({
                message: data.body.msg,
                type: 'danger'
              });
            }
          },
          function (data) {
            that.userListloading = false;
            let statusCode = data.status;
            that.$message({
              message: that.$t('queryFailedStatusCode') + statusCode,
              type: 'warning'
            });
          }
      );
    },
    addEquipDialog() {
      this.isEdit = false
      this.addDialogVisible = true;
      this.postData = {
        dtuNumber: '',
        equipmentTypeId: null,
        maxKeyCount: 0,
        name: '',
        number: '',
        saleWayId: null,
        group: '',// 设备分组
      }
    },
    confirmMap(mapdata) {
      this.chooseAdressVisible = false;
      var strs = mapdata.split("&")
      this.updateData.lanNlong = strs[0];
      var strs1 = strs[0].split(":");
      var strs2 = strs1[1].split(",");
      var strs3 = strs1[2].split("}");
      this.updateData.longitude = strs2[0]
      this.updateData.latitude = strs3[0]
      this.updateData.manualAddress = strs[1];
    },
    //修改设备
    updateEquip(e) {
      this.isEdit = true
      this.editDialogVisible = true;
      this.autoLocation = this.$t('equipmentmanagement.automaticPositioning')
      this.updateData.id = e.id;
      this.updateData.dtuNumber = e.dtuNumber;
      this.updateData.name = e.name;
      this.updateData.number = e.number;
      this.updateData.maxKeyCount = e.maxKeyCount;
      this.updateData.actualAddress = e.actualAddress
      if (e.simCard != null) {
        this.updateData.cardNumber = e.simCard.number;
      } else {
        this.updateData.cardNumber = ''
      }

      this.updateData.equipmentTypeName = e.equipmentTypeName;
      this.updateData.equipmentTypeId = e.equipmentTypeId;

      if (e.saleWay) {
        this.updateData.saleWayId = e.saleWay.id;
      } else {
        this.updateData.saleWayId = 0
      }
      //测试
      this.updateData.manualAddress = e.manualAddress
      this.updateData.lanNlong = "经度：" + e.longitude + " 纬度：" + e.latitude
      //投放地址设备获取的真实地址
      this.updateData.actualLatitude = e.actualLatitude;
      this.updateData.actualLongitude = e.actualLongitude;
      this.updateData.longitude = e.longitude;
      this.updateData.latitude = e.latitude;
      if (e.actualAddress == null) {
        this.equipData.autoLocation = this.$t('equipmentmanagement.theEquipmentHasNoLocationInformationTemporarily')
      } else {
        this.autoLocation = e.actualAddress
      }
      this.updateData.group = e.group
    },
    showEquipConfig(e) {
      this.equipmentCofigShow = true;
      this.equipmentInit = e;
    },
    cancelSelectCupTypeList() {
      this.chooseCupTypeVisible = false;
    },
    //给设备分配配方库
    confirmSelectCupTypeList() {
      this.chooseCupTypeVisible = false
    },
    //给设备批量分配配方库
    confirmMultiSelectCupTypeList() {
      if (this.isallselect) {
        let name = this.queryparam.name == undefined ? '' : this.queryparam.name;
        let equipmentNo = this.queryparam.equipmentNo == undefined ? '' : this.queryparam.equipmentNo;
        let salewayNo = this.queryparam.salewayNo == undefined ? '' : this.queryparam.salewayNo;
        let userName = this.queryparam.userName == undefined ? '' : this.queryparam.userName;
        let equipmentTypeId = this.queryparam.equipmentTypeId == undefined ? '' : this.queryparam.equipmentTypeId;
        if (this.$refs.seletcCup.selectedCupTypeList.length > 0) {
          let obj = []
          this.$refs.seletcCup.allselectedCupTypeList.forEach(element => {
            obj.push(element.id);
          });
          this.$httpservice.post("api/Equipment/BindCupType4SpecificEquipments?name=" + name + "&equipmentNo=" + equipmentNo + "&salewayNo=" + salewayNo + "&userName=" + userName + "&equipmentType_ID=" + equipmentTypeId, obj).then(res => {
            if (res.body.code == "200") {
              this.$message({
                message: this.$t('equipmentmanagement.batchAssignmentTaskCreatedSuccessfully'),
                type: 'success'
              });
              this.chooseMultiCupTypeVisible = false
            } else {
              this.$message({
                message: res.body.msg,
                type: 'warning'
              });
            }
          })
        } else {
          this.$message({
            message: this.$t('equipmentmanagement.pleaseSelectAtLeastOneRecipeLibrary'),
            type: 'warning'
          });
        }
      } else {
        console.log(this.allselectedEquipList)
        let obj = new Object();
        obj.equipmentIDs = [];
        this.allselectedEquipList.forEach(e => {
          obj.equipmentIDs.push(e.id)
        })
        obj.cupTypeIDs = [];
        if (this.$refs.seletcCup.selectedCupTypeList.length > 0) {
          let that = this;
          this.$refs.seletcCup.allselectedCupTypeList.forEach(element => {
            obj.cupTypeIDs.push(element.id);
          });
          this.$httpservice.post("api/Equipment/BatchBindCupType", obj).then(
              function (data) {
                if (data.body.code == "200") {
                  that.$message({
                    message: data.body.msg,
                    type: 'success'
                  });
                  that.chooseMultiCupTypeVisible = false;

                } else {
                  that.$message({
                    message: data.body.msg,
                    type: 'warning'
                  });
                }
              },
              function (data) {
                that.Beverageloading = false;
                let statusCode = data.status;
                that.$message({
                  message: that.$t('queryFailedStatusCode') + statusCode,
                  type: 'warning'
                });
              }
          );
        } else {
          this.$message({
            message: this.$t('equipmentmanagement.pleaseSelectAtLeastOneRecipeLibrary'),
            type: 'warning'
          });
        }
      }
    },
    showCopyDialog(e) {
      this.equipmentCopyInit = e
      this.equipmentCopyDialog = true
    },
    handleSizeChangepf(e) {
      this.pageSize = e;
      this.loadAssignedCupType(1);
    },
    handleCurrentChangepf(e) {
      this.loadAssignedCupType(e);
    },
    //加载已分配配方信息
    loadAssignedCupType(pageIndex) {
      this.cload = true;
      this.assignedCupDialogVisible = true;
      this.param = {
        pageIndex: pageIndex,
        pageSize: this.pageSize,
        dtuNo: this.assignInfo.dtuNumber
      };
      let that = this;
      this.$httpservice.get("api/Equipment/CupTypes", that.param).then(
          function (data) {
            if (data.body.code == "200") {
              that.cload = false;
              that.cupinfoList = data.body.data;
              that.cupTypeTotalCount = data.body.totalCount;
            } else {
              that.cload = false;
              that.$message({
                message: data.body.msg,
                type: 'danger'
              });
            }
          },
          function (data) {
            let statusCode = data.status;
            that.$message({
              message: that.$t('queryFailedStatusCode') + statusCode,
              type: 'warning'
            });
          }
      );
    },
    addClass(i) {
      switch (i) {

        case 0:
          return 'statusoffline';
        case 1:
          return 'statusonline'
      }
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
    },
    handleNodeClick(data) {
      console.log(data);
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        return resolve([{name: 'region1'}, {name: 'region2'}]);
      }
      if (node.level > 3) return resolve([]);

      var hasChild;
      if (node.data.name === 'region1') {
        hasChild = true;
      } else if (node.data.name === 'region2') {
        hasChild = false;
      } else {
        hasChild = Math.random() > 0.5;
      }

      setTimeout(() => {
        var data;
        if (hasChild) {
          data = [{
            name: 'zone' + this.count++
          }, {
            name: 'zone' + this.count++
          }];
        } else {
          data = [];
        }

        resolve(data);
      }, 100);
    },
    exportData() {
      let isZh = this.$i18n.locale
      this.querystr = this.$prefix + '/api/Equipment/ExportEquipmentList?';
      if (this.queryparam.name) {
        this.querystr = this.querystr + 'name=' + this.queryparam.name + '&';
      }
      if (this.queryparam.dtuNo) {
        this.querystr = this.querystr + 'dtuNo=' + this.queryparam.dtuNo + '&';
      }
      if (this.queryparam.equipmentNo) {
        this.querystr = this.querystr + 'equipmentNo=' + this.queryparam.equipmentNo + '&';
      }
      if (this.queryparam.salewayName) {
        this.querystr = this.querystr + 'salewayName=' + this.queryparam.salewayName + '&';
      }
      if (this.queryparam.equipmentTypeId) {
        this.querystr = this.querystr + 'equipmentTypeId=' + this.queryparam.equipmentTypeId + '&';
      }
      if (this.queryparam.userName) {
        this.querystr = this.querystr + 'userName=' + this.queryparam.userName + '&';
      }
      if (this.filterParam.equipmentTypeId) {
        this.querystr = this.querystr + 'equipmentTypeId=' + this.filterParam.equipmentTypeId + '&';
      }
      if (this.filterParam.salewayId) {
        this.querystr = this.querystr + 'salewayId=' + this.filterParam.salewayId + '&';
      }
      if (isZh) {
        this.querystr = this.querystr + 'lang=' + isZh;
      } else {
        this.querystr = this.querystr + 'lang=zh';
      }
      if (this.querystr.charAt(this.querystr.length - 1) == '&') {
        this.querystr = this.querystr.slice(0, this.querystr.length - 1)
      }
    },
    // 上传excel成功后的回调
    handleAvatarSuccessExcel(res, file) {
      console.log("上传结束", res)
      if (res.code == 200) {
        // 只会有一个，不支持多文件上传
        this.fileLibId = res.data[0] ? res.data[0].id : -1
      }
    },
    // 移除文件
    handleRemove() {
      this.fileLibId = -1
    },
    // 导入excel
    importNow() {
      // 获取到上传的文件的id
      if (this.fileLibId != -1) {
        this.$httpservice.get("api/Equipment/UploadExcel", {id: this.fileLibId}).then(res => {
          if (res.body.code == 200) {
            this.$message.success("请在我的任务中查看进度，不要重复导入！")
            this.uploadExcelDialog = false
            return
          } else {
            this.$message.error("文件解析失败，请检查数据准确性！")
            return
          }
        })
      } else {
        this.$message.error("请选择文件！")
        return
      }
    }
  },
  watch: {
    '$i18n.locale': {
      handler() {
      }
    }
  }
}
</script>
<style scoped>
.el-table-filter {
  max-height: 900px;
  overflow-y: auto;
}

/* 设备状态统计卡片样式 */
.stat-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 8px;
  padding: 10px 8px;
  text-align: center;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  border-left: 3px solid #dee2e6;
  min-height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.stat-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.stat-card .stat-label {
  font-size: 11px;
  color: #6c757d;
  margin-bottom: 4px;
}

.stat-card .stat-value {
  font-size: 20px;
  font-weight: 600;
  color: #212529;
  line-height: 1.2;
}

/* 在线状态 - 绿色 */
.stat-card.online {
  border-left-color: #28a745;
  background: linear-gradient(135deg, #f0fff4 0%, #e6fffa 100%);
}

.stat-card.online .stat-value {
  color: #28a745;
}

.stat-card.online .stat-label {
  color: #28a745;
}

/* 离线状态 - 灰色 */
.stat-card.offline {
  border-left-color: #6c757d;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.stat-card.offline .stat-value {
  color: #6c757d;
}

.stat-card.offline .stat-label {
  color: #6c757d;
}

/* 故障状态 - 红色 */
.stat-card.fault {
  border-left-color: #dc3545;
  background: linear-gradient(135deg, #fff5f5 0%, #ffe0e0 100%);
}

.stat-card.fault .stat-value {
  color: #dc3545;
}

.stat-card.fault .stat-label {
  color: #dc3545;
}

/* 缺料状态 - 橙色 */
.stat-card.shortage {
  border-left-color: #fd7e14;
  background: linear-gradient(135deg, #fffaf0 0%, #fff3e0 100%);
}

.stat-card.shortage .stat-value {
  color: #fd7e14;
}

.stat-card.shortage .stat-label {
  color: #fd7e14;
}

/* 选中状态 */
.stat-card--selected {
  border: 4px solid #516680 !important;
  box-shadow: 0 6px 20px rgba(81, 102, 128, 0.35) !important;
  transform: translateY(-3px);
}

.stat-card--selected .stat-value {
  font-weight: 800;
  color: #516680 !important;
}

.el-pager li {
  margin: 0 5px;
  background-color: #f4f4f5;
  color: #606266;
  min-width: 30px;
  border-radius: 2px;
}

.el-pager li:not(.disabled).active {
  background-color: #516680;
  color: #FFF;
}

.statusonline {
  color: green;
}

.statusoffline {
  color: red;
}

.bgcoloraaa {
  background-color: #113874 !important;
  border: 0 !important;
  outline: none !important;
  color: white !important;
}

.usertag {
  margin-right: 5px;
  margin-left: 5px;
  margin-bottom: 10px;
}

.weizhi {
  display: flex;
  align-items: center;
}


.dialog-footer {
  padding: 0px 15px 25px 25px;;
}

a:-webkit-any-link {
  color: #000000;
}

.spanStyle {
  width: 120px;
  text-align: center;
  margin-bottom: 0px !important;
  display: inline-block;
  /* white-space: nowrap; */
  margin: 5px 0px;
  /* overflow-y: hidden;
  overflow-x: auto; */
  /* text-overflow: ellipsis; 溢出用省略号 */
  height: 30px;
  line-height: 30px;
}

/* .spanStyle::-webkit-scrollbar {
  width: 0px!important;
  height: 0px!important;
} */
.el-link.el-link--default {
  display: block !important;
  height: 32px !important;
  width: 56px !important;
  margin: -9px;
  text-align: center;
  vertical-align: middle;
}
</style>
<style lang="less">
.el-table-filter {
  max-height: 900px;
  overflow-y: auto;
}

.chineseForm {
  .el-form-item__label {
    font-size: 15px !important;
  }
}

.englishForm {
  .el-form-item__label {
    font-size: 12px !important;
  }
}

#equipmentmanagement {
  .englishStyle {
    @media screen and (max-width: 1366px) {
      .el-table {
        height: 95vh !important;

      }
    }
    @media screen and (min-width: 1367px) and (max-width: 1920px) and (max-height: 1200px) {
      .el-table {
        height: 68vh !important;

      }
    }

    .el-table th {
      font-size: 15px !important;
    }
  }

  .chineseStyle {
    @media screen and (max-width: 1366px) {
      .el-table {
        height: 95vh !important;

      }
    }
    @media screen and (min-width: 1367px) and (max-width: 1920px) and (max-height: 1200px) {
      .el-table {
        height: 68vh !important;

      }
    }

    .el-table th {
      font-size: 15px !important;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/equipmentmanagement/equipmentmanagement.vue